import React from 'react';

import "./LoginButton.scss";
import { Button } from '@randajan/jet-react/dom/form';
import { usePagePop } from '../../../hooks/usePagePop';
import { LoginScreen } from '../LoginScreen/LoginScreen';

export const LoginButton = (props)=>{
    const {} = props;
    
    const popLogin = usePagePop(<LoginScreen/>, "hash.sign", "up");

    return (
        <Button className="LoginButton" onSubmit={_=>popLogin.up()}>Přihlásit se</Button>
    )
}
